export default {"src":"/_next/static/media/cw_icon.6851b70a.svg","height":739,"width":1047,"blurWidth":0,"blurHeight":0};